// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file chat/chat_model.proto (package com.gem.bff.contract, syntax proto3)

/* eslint-disable */
import type { Message } from '@bufbuild/protobuf';
import type { GenEnum, GenFile, GenMessage } from '@bufbuild/protobuf/codegenv2';
import { enumDesc, fileDesc, messageDesc } from '@bufbuild/protobuf/codegenv2';

import type { DeepLinkInfo } from '../common/common_model_pb';
import { file_common_common_model } from '../common/common_model_pb';
import type { Device } from '../device/device_model_pb';
import { file_device_device_model } from '../device/device_model_pb';
import type { UserMention } from '../message/message_model_pb';
import { file_message_message_model } from '../message/message_model_pb';
import type { PersonalizedUser } from '../user/user_model_pb';
import { file_user_user_model } from '../user/user_model_pb';

/**
 * Describes the file chat/chat_model.proto.
 */
export const file_chat_chat_model: GenFile =
  /*@__PURE__*/
  fileDesc(
    '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',
    [
      file_common_common_model,
      file_user_user_model,
      file_message_message_model,
      file_device_device_model,
    ]
  );

/**
 * @generated from message com.gem.bff.contract.PersonalizedChat
 */
export type PersonalizedChat = Message<'com.gem.bff.contract.PersonalizedChat'> & {
  /**
   * @generated from field: com.gem.bff.contract.Chat chat = 1;
   */
  chat?: Chat;

  /**
   * @generated from field: int32 pinOrder = 2;
   */
  pinOrder: number;

  /**
   * @generated from field: bool muted = 3;
   */
  muted: boolean;

  /**
   * @generated from field: optional com.gem.bff.contract.PersonalizedUser opponent = 4;
   */
  opponent?: PersonalizedUser;

  /**
   * @generated from field: optional com.gem.bff.contract.Chat.Role role = 5;
   */
  role?: Chat_Role;

  /**
   * @generated from field: optional com.gem.bff.contract.UserChatDraftInput draftInput = 6;
   */
  draftInput?: UserChatDraftInput;

  /**
   * @generated from field: bool unread = 7;
   */
  unread: boolean;
};

/**
 * Describes the message com.gem.bff.contract.PersonalizedChat.
 * Use `create(PersonalizedChatSchema)` to create a new message.
 */
export const PersonalizedChatSchema: GenMessage<PersonalizedChat> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_model, 0);

/**
 * @generated from message com.gem.bff.contract.Chat
 */
export type Chat = Message<'com.gem.bff.contract.Chat'> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string;

  /**
   * @generated from field: com.gem.bff.contract.Chat.Type type = 4;
   */
  type: Chat_Type;

  /**
   * @generated from field: optional string avatarUrl = 5;
   */
  avatarUrl?: string;

  /**
   * @generated from field: int32 usersCount = 6;
   */
  usersCount: number;

  /**
   * @generated from field: repeated int64 pinnedMessageIds = 7;
   */
  pinnedMessageIds: bigint[];

  /**
   * @generated from field: com.gem.bff.contract.DeepLinkInfo deepLinkInfo = 8;
   */
  deepLinkInfo?: DeepLinkInfo;

  /**
   * @generated from field: repeated com.gem.bff.contract.UserMention descriptionMentions = 9;
   */
  descriptionMentions: UserMention[];

  /**
   * @generated from field: optional int64 ttlPeriodMs = 10;
   */
  ttlPeriodMs?: bigint;

  /**
   * @generated from field: int32 activeChatAccessRequestCount = 11;
   */
  activeChatAccessRequestCount: number;
};

/**
 * Describes the message com.gem.bff.contract.Chat.
 * Use `create(ChatSchema)` to create a new message.
 */
export const ChatSchema: GenMessage<Chat> = /*@__PURE__*/ messageDesc(file_chat_chat_model, 1);

/**
 * @generated from enum com.gem.bff.contract.Chat.Type
 */
export enum Chat_Type {
  /**
   * @generated from enum value: SYSTEM = 0;
   */
  SYSTEM = 0,

  /**
   * @generated from enum value: CLOSED_GROUP = 1;
   */
  CLOSED_GROUP = 1,

  /**
   * @generated from enum value: OPEN_GROUP = 2;
   */
  OPEN_GROUP = 2,

  /**
   * @generated from enum value: CLOSED_CHANNEL = 3;
   */
  CLOSED_CHANNEL = 3,

  /**
   * @generated from enum value: OPEN_CHANNEL = 4;
   */
  OPEN_CHANNEL = 4,

  /**
   * @generated from enum value: P2P = 5;
   */
  P2P = 5,

  /**
   * @generated from enum value: SAVED_MESSAGES = 6;
   */
  SAVED_MESSAGES = 6,

  /**
   * @generated from enum value: THREAD = 7;
   */
  THREAD = 7,

  /**
   * @generated from enum value: SECRET_GROUP = 8;
   */
  SECRET_GROUP = 8,

  /**
   * @generated from enum value: SERVICE_MESSAGES = 9;
   */
  SERVICE_MESSAGES = 9,
}

/**
 * Describes the enum com.gem.bff.contract.Chat.Type.
 */
export const Chat_TypeSchema: GenEnum<Chat_Type> =
  /*@__PURE__*/
  enumDesc(file_chat_chat_model, 1, 0);

/**
 * @generated from enum com.gem.bff.contract.Chat.Role
 */
export enum Chat_Role {
  /**
   * @generated from enum value: OWNER = 0;
   */
  OWNER = 0,

  /**
   * @generated from enum value: ADMIN = 1;
   */
  ADMIN = 1,

  /**
   * @generated from enum value: MEMBER = 2;
   */
  MEMBER = 2,

  /**
   * @generated from enum value: GUEST = 3;
   */
  GUEST = 3,
}

/**
 * Describes the enum com.gem.bff.contract.Chat.Role.
 */
export const Chat_RoleSchema: GenEnum<Chat_Role> =
  /*@__PURE__*/
  enumDesc(file_chat_chat_model, 1, 1);

/**
 * @generated from message com.gem.bff.contract.UserChatDraftInput
 */
export type UserChatDraftInput = Message<'com.gem.bff.contract.UserChatDraftInput'> & {
  /**
   * @generated from field: optional string text = 1;
   */
  text?: string;

  /**
   * @generated from field: int64 updateTs = 2;
   */
  updateTs: bigint;

  /**
   * @generated from field: int64 chatId = 3;
   */
  chatId: bigint;
};

/**
 * Describes the message com.gem.bff.contract.UserChatDraftInput.
 * Use `create(UserChatDraftInputSchema)` to create a new message.
 */
export const UserChatDraftInputSchema: GenMessage<UserChatDraftInput> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_model, 2);

/**
 * @generated from message com.gem.bff.contract.UserPinnedChats
 */
export type UserPinnedChats = Message<'com.gem.bff.contract.UserPinnedChats'> & {
  /**
   * @generated from field: repeated int64 chatIds = 1;
   */
  chatIds: bigint[];
};

/**
 * Describes the message com.gem.bff.contract.UserPinnedChats.
 * Use `create(UserPinnedChatsSchema)` to create a new message.
 */
export const UserPinnedChatsSchema: GenMessage<UserPinnedChats> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_model, 3);

/**
 * @generated from message com.gem.bff.contract.ChatParticipant
 */
export type ChatParticipant = Message<'com.gem.bff.contract.ChatParticipant'> & {
  /**
   * @generated from field: com.gem.bff.contract.PersonalizedUser user = 1;
   */
  user?: PersonalizedUser;

  /**
   * @generated from field: com.gem.bff.contract.Chat.Role role = 2;
   */
  role: Chat_Role;
};

/**
 * Describes the message com.gem.bff.contract.ChatParticipant.
 * Use `create(ChatParticipantSchema)` to create a new message.
 */
export const ChatParticipantSchema: GenMessage<ChatParticipant> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_model, 4);

/**
 * @generated from message com.gem.bff.contract.SecretChatAccessRequest
 */
export type SecretChatAccessRequest = Message<'com.gem.bff.contract.SecretChatAccessRequest'> & {
  /**
   * @generated from field: int64 chatId = 1;
   */
  chatId: bigint;

  /**
   * @generated from field: com.gem.bff.contract.SecretChatAccessRequest.Status status = 2;
   */
  status: SecretChatAccessRequest_Status;

  /**
   * @generated from field: int64 userId = 3;
   */
  userId: bigint;

  /**
   * @generated from field: string deviceId = 4;
   */
  deviceId: string;

  /**
   * @generated from field: com.gem.bff.contract.Device device = 5;
   */
  device?: Device;
};

/**
 * Describes the message com.gem.bff.contract.SecretChatAccessRequest.
 * Use `create(SecretChatAccessRequestSchema)` to create a new message.
 */
export const SecretChatAccessRequestSchema: GenMessage<SecretChatAccessRequest> =
  /*@__PURE__*/
  messageDesc(file_chat_chat_model, 5);

/**
 * @generated from enum com.gem.bff.contract.SecretChatAccessRequest.Status
 */
export enum SecretChatAccessRequest_Status {
  /**
   * @generated from enum value: REQUESTED = 0;
   */
  REQUESTED = 0,

  /**
   * @generated from enum value: ACCEPTED = 1;
   */
  ACCEPTED = 1,

  /**
   * @generated from enum value: DECLINED = 2;
   */
  DECLINED = 2,
}

/**
 * Describes the enum com.gem.bff.contract.SecretChatAccessRequest.Status.
 */
export const SecretChatAccessRequest_StatusSchema: GenEnum<SecretChatAccessRequest_Status> =
  /*@__PURE__*/
  enumDesc(file_chat_chat_model, 5, 0);
